import WolfAvatar from '@components/ui/WolfAvatar';
import WolfButton from '@components/ui/WolfButton';
import { UploadIcon24 } from '@components/ui/WolfIcons';
import { useTranslation } from '@hooks/useTranslation';
import { Box } from '@mui/material';
import { VisuallyHiddenInput } from './VisuallyHiddenInput';

type ProfilePictureProps = {
  src?: string;
  name?: string;
  handleImageChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const ProfilePicture: React.FC<ProfilePictureProps> = ({ src, name, handleImageChange }) => {
  const localeSettings = useTranslation('settings');

  return (
    <Box className="flex flex-wrap justify-end items-center gap-2">
      <WolfAvatar src={src || ''} alt={name || 'User'} size="104px" />
      {handleImageChange && (
        <label>
          <VisuallyHiddenInput type="file" accept="image/png, image/jpeg, image/gif" onChange={handleImageChange} />
          <WolfButton
            className="text-wrap"
            component="span"
            variant="outlined"
            color="primary"
            startIcon={<UploadIcon24 />}>
            {localeSettings['changeAvatar']}
          </WolfButton>
        </label>
      )}
    </Box>
  );
};

export default ProfilePicture;
